import { StyleSheet, Text } from 'react-native'
import * as Icons from '../../icons'

import { useCardActivityFeedBottomSheetAnimatedHeight, type BottomSheetProps } from './bottom-sheet'
import { mesaColorNames, typography } from '@/src/common/theme'
import Animated from 'react-native-reanimated'
import { Header } from './header'

export const Empty = ({
  cardActivityFeedBottomSheetHeightStore: { maxHeight, minHeight, animatedIndex },
}: BottomSheetProps) => {
  const emptyStateAnimatedStyles = useCardActivityFeedBottomSheetAnimatedHeight(
    maxHeight,
    minHeight,
    animatedIndex,
    { justifyContent: 'center', alignItems: 'center' },
    188,
  )

  return (
    <>
      <Header>Transactions</Header>
      <Animated.View style={emptyStateAnimatedStyles}>
        <Icons.NoTransactions
          pathProps={{
            stroke: mesaColorNames['Mesa - Brand/Blackish #222222'],
          }}
        />
        <Text style={styles.text}>No recent transactions</Text>
      </Animated.View>
    </>
  )
}

const styles = StyleSheet.create({
  text: {
    marginTop: 16,
    ...typography['label/lg-regular'],
    color: 'black',
  },
})
